// src/stone/icons/DollarOff2X.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var DollarOff2X = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 40 40",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M20 5.667a1 1 0 0 1 1 1v26.666a1 1 0 1 1-2 0V6.667a1 1 0 0 1 1-1" }),
      /* @__PURE__ */ jsx("path", { d: "M2.626 2.626a1 1 0 0 1 1.415 0L37.374 35.96a1 1 0 1 1-1.414 1.414L2.626 4.04a1 1 0 0 1 0-1.414" }),
      /* @__PURE__ */ jsx("path", { d: "M13.741 12.205c.91-.976 2.161-1.538 3.481-1.538h8.333a1 1 0 1 1 0 2h-8.333c-.743 0-1.47.315-2.019.902-.55.59-.87 1.403-.87 2.264 0 .862.32 1.675.87 2.264.548.587 1.276.903 2.02.903h5.555c1.32 0 2.57.562 3.48 1.538a5.32 5.32 0 0 1 1.409 3.629c0 1.348-.5 2.655-1.408 3.628-.911.976-2.162 1.538-3.481 1.538h-9.445a1 1 0 1 1 0-2h9.445c.743 0 1.47-.315 2.019-.902.55-.59.87-1.403.87-2.264 0-.862-.32-1.675-.87-2.264-.548-.587-1.276-.903-2.02-.903h-5.555c-1.32 0-2.57-.562-3.48-1.538a5.32 5.32 0 0 1-1.409-3.629c0-1.349.5-2.655 1.408-3.628" }),
      /* @__PURE__ */ jsx("path", { d: "M20 2.667c-3.19 0-6.177.86-8.743 2.363a1 1 0 1 1-1.01-1.726A19.25 19.25 0 0 1 20 .667C30.678.667 39.333 9.322 39.333 20c0 3.52-.941 6.823-2.587 9.667a1 1 0 0 1-1.73-1.001A17.25 17.25 0 0 0 37.332 20c0-9.573-7.76-17.333-17.333-17.333m-15.38 7.3a1 1 0 0 1 .365 1.367A17.25 17.25 0 0 0 2.667 20c0 9.573 7.76 17.333 17.333 17.333 3.159 0 6.118-.844 8.666-2.318a1 1 0 0 1 1.002 1.731A19.25 19.25 0 0 1 20 39.333C9.323 39.333.667 30.678.667 20c0-3.52.941-6.823 2.587-9.667a1 1 0 0 1 1.366-.365" })
    ]
  }
);
var DollarOff2X_default = DollarOff2X;

export {
  DollarOff2X_default
};
